/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_State_PausedInputs */

const en_wb_state_paused = /** @type {(inputs: Wb_State_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example paused. Nothing is sent or changed in your tools.`)
};

const lv_wb_state_paused = /** @type {(inputs: Wb_State_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piemērs apturēts. Nekas netiek sūtīts vai mainīts Jūsu rīkos.`)
};

/**
* | output |
* | --- |
* | "Example paused. Nothing is sent or changed in your tools." |
*
* @param {Wb_State_PausedInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_state_paused = /** @type {((inputs?: Wb_State_PausedInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_State_PausedInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_state_paused(inputs)
	return en_wb_state_paused(inputs)
});